/**
 * Comprados Juntos Component
 * Gerencia a seleção de produtos e adição ao carrinho
 * Segue o padrão nativo do tema usando ThemeEvents.cartUpdate
 */
class CompradosJuntosComponent extends HTMLElement {
    constructor() {
        super();
        this.selectedProducts = new Map();
    }

    connectedCallback() {
        this.currentVariantId = this.dataset.currentVariantId;
        this.currentPrice = parseInt(this.dataset.currentPrice, 10) || 0;

        // Adicionar produto atual (sempre selecionado)
        this.selectedProducts.set(this.currentVariantId, {
            id: this.currentVariantId,
            quantity: 1,
            price: this.currentPrice
        });

        this.totalElement = this.querySelector('[ref="totalValue"]');
        this.addButton = this.querySelector('[ref="addButton"]');
        this.originalButtonText = this.addButton?.textContent || 'Adicionar ao Carrinho';

        this.setupCheckboxes();
        this.updateTotal();
        this.setupAddButton();
    }

    setupCheckboxes() {
        const checkboxes = this.querySelectorAll('.comprados-juntos-card__checkbox');

        checkboxes.forEach(checkbox => {
            const variantId = checkbox.dataset.variantId;
            const price = parseInt(checkbox.dataset.price, 10) || 0;
            const isCurrent = checkbox.dataset.isCurrent === 'true';

            // Registrar produtos já selecionados no carregamento
            if (checkbox.checked) {
                this.selectedProducts.set(variantId, {
                    id: variantId,
                    quantity: 1,
                    price: price
                });
            }

            // Ignorar o checkbox do produto atual (já está sempre selecionado)
            if (isCurrent) {
                return;
            }

            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    this.selectedProducts.set(variantId, {
                        id: variantId,
                        quantity: 1,
                        price: price
                    });
                } else {
                    this.selectedProducts.delete(variantId);
                }

                this.updateTotal();
            });
        });

        // Atualizar total inicial
        this.updateTotal();
    }

    updateTotal() {
        if (!this.totalElement) return;

        let total = 0;
        this.selectedProducts.forEach(product => {
            total += product.price;
        });

        // Formatar como moeda brasileira
        const formattedTotal = this.formatMoney(total);
        this.totalElement.textContent = formattedTotal;
    }

    formatMoney(cents) {
        const amount = cents / 100;
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(amount);
    }

    setupAddButton() {
        if (!this.addButton) return;

        this.addButton.addEventListener('click', async (event) => {
            event.preventDefault();

            const items = Array.from(this.selectedProducts.values()).map(product => ({
                id: parseInt(product.id, 10),
                quantity: 1
            }));

            if (items.length === 0) return;

            this.addButton.disabled = true;
            this.addButton.textContent = 'Adicionando...';

            try {
                const response = await fetch(Theme.routes.cart_add_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ items })
                });

                const data = await response.json();

                if (data.status) {
                    // Erro
                    console.error('Erro ao adicionar:', data.message);
                    this.addButton.textContent = data.message || 'Erro ao adicionar';
                    setTimeout(() => {
                        this.addButton.textContent = this.originalButtonText;
                        this.addButton.disabled = false;
                    }, 3000);
                    return;
                }

                // Sucesso - disparar evento nativo do tema
                this.dispatchCartUpdateEvent(items.length);

                // Atualizar UI
                this.addButton.textContent = 'Adicionado!';
                this.addButton.classList.add('atc-added');

                setTimeout(() => {
                    this.addButton.textContent = this.originalButtonText;
                    this.addButton.disabled = false;
                    this.addButton.classList.remove('atc-added');
                }, 2000);

            } catch (error) {
                console.error('Erro ao adicionar produtos:', error);
                this.addButton.textContent = 'Erro ao adicionar';
                setTimeout(() => {
                    this.addButton.textContent = this.originalButtonText;
                    this.addButton.disabled = false;
                }, 2000);
            }
        });
    }

    dispatchCartUpdateEvent(itemCount) {
        // Disparar evento cart:update no document (padrão do tema)
        // Este é o evento que cart-icon.js e cart-drawer.js escutam
        const cartUpdateEvent = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
                source: 'comprados-juntos',
                sourceId: this.id || 'comprados-juntos',
                data: {
                    source: 'comprados-juntos',
                    itemCount: itemCount
                }
            }
        });

        document.dispatchEvent(cartUpdateEvent);

        // Tentar abrir o drawer do carrinho se existir e tiver atributo auto-open
        const cartDrawer = document.querySelector('cart-drawer[auto-open]');
        if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
            cartDrawer.showDialog();
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
        }
    }
}

if (!customElements.get('comprados-juntos-component')) {
    customElements.define('comprados-juntos-component', CompradosJuntosComponent);
}
